import { useEffect, useMemo, useState } from "react";
import { normalizeSearch } from "../controleFormat";
import { CHARTER_THEME } from "../controleTheme";
import { buttonBase, ehpadOptionStyle } from "../styles/layoutStyles";

export function SearchableEhpadField({ id, ehpads, value, onChange, placeholder, allowClear = false, style = {} }) {
    const { inputStyle } = CHARTER_THEME;
    const selected = ehpads.find(e => String(e.id) === String(value));
    const [query, setQuery] = useState(selected?.nom || "");
    const [open, setOpen] = useState(false);

    useEffect(() => {
        setQuery(selected?.nom || "");
    }, [selected?.id, selected?.nom]);

    const matches = useMemo(() => {
        const normalizedQuery = normalizeSearch(query);
        if (!normalizedQuery) return ehpads.slice(0, 60);
        return ehpads
            .filter(ehpad => normalizeSearch(`${ehpad.nom} ${ehpad.code || ""} ${ehpad.tournee || ""}`).includes(normalizedQuery))
            .slice(0, 60);
    }, [ehpads, query]);

    const selectEhpad = (ehpad) => {
        onChange(String(ehpad.id));
        setQuery(ehpad.nom);
        setOpen(false);
    };

    const clear = () => {
        onChange("");
        setQuery("");
        setOpen(false);
    };

    return (
        <div style={{ position: "relative", ...style }}>
            <div style={{ display: "flex", gap: "6px" }}>
                <input
                    id={id}
                    style={{ ...inputStyle, width: "100%" }}
                    value={query}
                    placeholder={placeholder}
                    onChange={event => {
                        setQuery(event.target.value);
                        setOpen(true);
                        if (value) onChange("");
                    }}
                    onFocus={() => setOpen(true)}
                    autoComplete="off"
                />
                {allowClear && value && (
                    <button type="button" onClick={clear} style={{ ...buttonBase, padding: "7px 9px", background: "white", color: "#475569" }}>
                        Tous
                    </button>
                )}
            </div>
            {open && (
                <div style={{
                    position: "absolute",
                    top: "calc(100% + 4px)",
                    left: 0,
                    right: 0,
                    maxHeight: "320px",
                    overflowY: "auto",
                    background: "white",
                    border: "1px solid #cbd5e1",
                    borderRadius: "7px",
                    boxShadow: "0 10px 24px rgba(15, 23, 42, 0.12)",
                    zIndex: 20,
                }}>
                    {allowClear && (
                        <button
                            type="button"
                            onMouseDown={event => event.preventDefault()}
                            onClick={clear}
                            style={ehpadOptionStyle}
                        >
                            Tous les EHPAD
                        </button>
                    )}
                    {matches.map(ehpad => (
                        <button
                            key={ehpad.id}
                            type="button"
                            onMouseDown={event => event.preventDefault()}
                            onClick={() => selectEhpad(ehpad)}
                            style={{
                                ...ehpadOptionStyle,
                                background: String(ehpad.id) === String(value) ? "#eff6ff" : "white",
                            }}
                        >
                            <span style={{ fontWeight: 700 }}>{ehpad.nom}</span>
                            {ehpad.tournee && <span style={{ color: "#64748b" }}> · {ehpad.tournee}</span>}
                        </button>
                    ))}
                    {matches.length === 0 && (
                        <div style={{ padding: "10px 12px", color: "#94a3b8", fontSize: "13px" }}>
                            Aucun EHPAD trouvé.
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}
